import React from 'react';

import { GetRegion } from 'constants.js';
import { converter } from 'helpers/converter';
import { connect } from 'react-redux';
import termsTask from 'requests/tasks/termsTask';
import RequestManager from 'requests/RequestManager';
import { execSafePushSession } from 'utils/getStickySession';
import api, { updateDefaults } from 'services/api/microfwk';
import apiSticky, { updateDefaultsSticky } from 'services/api/microfwkSticky';
import { setHKS } from 'utils/HKS';
import _ from 'lodash';
import IpTelmexTerms from './IpTelmexTerms';
import getFirstNode from 'utils/getFirstNode';

export class IpTelmexTermsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: false,
      success: false,
      isValidForm: true,
      form: {
        terms: 1,
      },
      submitted: false,
      errors: {},
    };
  }

  firstNode = getFirstNode();

  save = () => {
    this.setState({ loading: true });
    const userData = this.props.user;
    let customEndPoint = window.localStorage.getItem('customEndPoint');
    window.localStorage.removeItem('customEndPoint');
    if (customEndPoint) {
      try {
        customEndPoint = atob(customEndPoint);
      } catch (e) {
        customEndPoint = customEndPoint;
      }
      customEndPoint = customEndPoint.replace('http:', 'https:');
    }
    const termsOptions = {
      ...(userData && userData.user_id && { user_id: userData.user_id }),
      ...(userData && userData.userhash && { user_hash: userData.userhash }),
      customEndPoint,
    };
    const terms = new termsTask(termsOptions);
    RequestManager.addRequest(terms)
      .then(result => {
        try {
          const userId = _.get(
            result,
            ['response', 'userData', 'user_id'],
            false,
          );
          const hks = _.get(
            result,
            ['response', 'userData', 'session_stringvalue'],
            null,
          );
          if (hks) {
            setHKS(hks);
            updateDefaults(api, { params: { HKS: hks } });
            updateDefaultsSticky(apiSticky, { params: { HKS: hks } });
          }
          if (userId)
            execSafePushSession(_.get(result, ['response', 'userData'], {}));
        } catch (err) {
          console.error('push session', err);
        }
        localStorage.setItem('loginInfo.acceptedTerms', 1);
        localStorage.removeItem('loginIng.ip_telmex');
        this.setState({ loading: false });
        window.location = `/${GetRegion()}/${
          this.firstNode
        }${window.location.search.toString()}`;
      })
      .catch(err => {
        this.setState({ loading: false });
        const error =
          err.message ||
          converter.convertApaUnicode(
            this.props.translations,
            'missing_accepterms',
          );

        this.setState({ error });
      });
  };

  render() {
    const info = JSON.parse(localStorage.getItem('loginIng.ip_telmex'));

    return (
      <IpTelmexTerms
        isValidForm={this.state.isValidForm}
        success={this.state.success}
        loading={this.state.loading}
        submitted={this.state.submitted}
        termsValue={this.state.form.terms}
        termsError={this.state.errors.terms || this.state.error || ''}
        handleSubmit={this.save}
        translations={this.props.translations}
        info={info}
        origin={this.props.config.origin}
        assets={this.props.asset}
      />
    );
  }
}

const mapStateToProps = state => ({
  config: state.config,
  metadata: state.metadata,
  translations: state.translations,
  user: state.user,
  asset: state.asset,
});

export default connect(mapStateToProps)(IpTelmexTermsContainer);
